<div class="header bg-primary text-white">
	<h3 mat-dialog-title class="d-flex align-items-center">
		<span class="col pl-0">{{this.data.videoMsg ? 'Add Video' : heading}}</span>
		<button mat-button type="button" (click)="closeDialog()"><i class="fas fa-times"></i></button>
	</h3>
</div>
<mat-dialog-content class="p-0">
	<app-create-post [module]="data.module" [item_id]="data.id" [addPhoto]="'addPhoto'" (photoCloseDialog)="closeDialog()" [accept]="data.accept"></app-create-post>
</mat-dialog-content>
